var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3575 0.912414V14.2883C23.3575 14.5294 23.2617 14.7605 23.0913 14.9309C22.9209 15.1014 22.6897 15.1972 22.4487 15.1972H16.3393L19.6495 19.8468C19.7619 20.0046 19.8069 20.2005 19.7747 20.3915C19.7426 20.5824 19.6358 20.7528 19.478 20.865C19.3553 20.9522 19.2087 20.9994 19.0583 21C18.8208 21.0013 18.5975 20.887 18.4598 20.6935L14.5474 15.1971H8.81014L4.89773 20.6935C4.76075 20.8859 4.53907 21.0001 4.30287 21C4.15116 21.0001 4.00313 20.9529 3.87946 20.865C3.72169 20.7528 3.61488 20.5824 3.58281 20.3915C3.55061 20.2005 3.59564 20.0045 3.70802 19.8468L7.01824 15.1972H0.912408C0.670762 15.1981 0.438625 15.1028 0.267427 14.9322C0.0962316 14.7617 0 14.5299 0 14.2883V0.912414C0 0.670413 0.0961131 0.438266 0.267189 0.26719C0.438385 0.0961135 0.670413 0 0.912414 0H22.4452C22.6872 0 22.9193 0.0961135 23.0905 0.26719C23.2615 0.438266 23.3576 0.670413 23.3576 0.912414H23.3575Z",
    fill: "#DBDFF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.d99684d8aa7b9a9628c5f9d47b3bd6c4.svg";
export { ForwardRef as ReactComponent };